import { useState, useEffect } from 'react';

function extractStatus(metadata) {
  return {
    Status: metadata['Status'],
    'Detailed Status': metadata['Detailed Status']
  };
}

export default function useInitialStatus(metadata) {
  const [initialStatus, setInitialStatus] = useState();

  useEffect(() => {
    if (metadata) {
      setInitialStatus(extractStatus(metadata));
    }
  }, [metadata]);

  return initialStatus;
}
